<template>
  <div :class="styles.communityDetail">
    <van-nav-bar class="nav-bar" :title="$t('foorter.community')">
      <template #left>
        <van-icon name="arrow-left" color="#000" @click="back()"
      /></template>
    </van-nav-bar>
    <div :class="styles.container">
      <img
        :src="`/img/community/img-${detailData.id}.jpg`"
        :class="styles.communityDetailImg"
        alt="image"
      />
      <div :class="styles.communityDetailTitle">
        <h1>{{ detailData.title }}</h1>
      </div>
      <div :class="styles.communityDetailContent">
        <div v-html="detailData.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import data from "../../data.json";
import styles from "./style.module.scss";
export default {
  name: "CommunityDetail",
  data() {
    return {
      data,
      detailData: {},
      styles,
    };
  },
  methods: {
    getCommunityDetail() {
      this.detailData = this.data.communityData.find((item) => {
        return item.id === parseInt(this.$route.params.key);
      });
      console.debug("detailData", this.detailData);
    },
    back() {
      this.$router.back();
    },
    toTop() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.getCommunityDetail();
    this.toTop();
  },
};
</script>

<style lang='less' scoped>
.nav-bar {
  background: unset;
  height: 100px;
  color: #000;
}
.van-nav-bar {
  line-height: 50px;
}
::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #000;
  font-size: 35px;
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
</style>